import { Instance, types } from 'mobx-state-tree';

const SupportedPlatformsModel = types.model('SupportedPlatformsModel', {
    wwise_versions: types.frozen<Record<string, { id: string; name: string }>>({}),
    platforms: types.frozen<Record<string, { id: string; name: string }>>({}),
    integrations: types.frozen<Record<string, { id: string; name: string }>>({}),
    plugins: types.frozen<Record<string, { name: string; moreInfoLink?: string }>>({}),
    requires_dev_status_confirmation: types.frozen<string[]>([]),
    defaults: types.frozen<{
        platforms: string[];
        integrations: string[];
        plugins: string[];
        wwise_version: string;
    }>({
        platforms: [],
        integrations: [],
        plugins: [],
        wwise_version: '',
    }),
    not_supported: types.frozen<Record<string, string[][]>>({}),
});
export type TypeSupportedPlatformModel = Instance<typeof SupportedPlatformsModel>;

export default SupportedPlatformsModel;
